export default __webpack_public_path__ + "static/GT-Haptik-Light-2-40ee8af75c95dd99e2e5b551fb97305a.ttf";